<script setup lang="ts">
defineProps<{
  content: string
}>()
</script>

<template>
  <div class="flex justify-end animate-slide-up">
    <!-- Message bubble -->
    <div class="max-w-[80%] bg-primary text-white rounded-2xl rounded-br-md px-4 py-3 shadow-sm">
      <p class="text-sm whitespace-pre-wrap leading-relaxed">{{ content }}</p>
    </div>
  </div>
</template>
